import { useEffect, useState } from "react";
import moment from "moment";

// Same approved working-hour rule as the Calendar screen (SchedulerTest.jsx's
// CANONICAL_HOURS): full hours only, 12:00-14:00 shown as a compact
// non-interactive break instead of selectable rows.
// Lives in its own module (not TimeslotsSection.js) so CopyWeekModal can import it without
// creating a circular dependency (TimeslotsSection.js imports that modal).
export const HOUR_ROWS = [8, 9, 10, 11, "break", 15, 16, 17, 18, 19, 20, 21];
export const DAYS_PER_WEEK = 6;
export const WEEK_DAY_LABELS = ["PON", "UTO", "SRE", "ČET", "PET", "SUB"];

export const useIsDesktopTablet = () => {
  const [isDesktopTablet, setIsDesktopTablet] = useState(
    typeof window !== "undefined" ? window.innerWidth >= 768 : false
  );
  useEffect(() => {
    const onResize = () => setIsDesktopTablet(window.innerWidth >= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return isDesktopTablet;
};

export function cellKey(date, hour) {
  return moment(date).hour(hour).minute(0).second(0).format("YYYY-MM-DD HH:mm:ss");
}
